<main>
  <div class="row">
    <label for="Campos obrigatórios" style="color:#DB3347"><span class="mandatory"></span>{{'Workflow.Mandatory' | translate}}</label>
    <div class="col-sm-12">
      <h1 class="text-primary mb-4">{{'PrestacoesMorte.StepBeneficiary.Cards.BeneficiaryList.TitleBeneficiariesPreStage' | translate}}</h1>
    </div>
  </div>

  <div class="row">
    <div class="col-sm-12 text-end">
      <button (click)="expandNewBeneficiary=!expandNewBeneficiary;expandNewItem(true)"
              *ngIf="isFuneraryOrService?.toString()=='true'"
              [ngClass]="!expandNewBeneficiary ? '' : 'disabled'"
              aria-label="Nova entrada"
              type="button"
              class="btn btn-link">
        <span class="icon-add"></span> <span>{{ 'PrestacoesMorte.StepBeneficiary.Cards.BeneficiaryList.Fields.AddItem' | translate}}</span>
      </button>
    </div>
  </div>

  <div class="row">
    <div class="col-sm-12">
      <table class="table table-striped">
        <thead>
          <tr>
            <th scope="col" class="icon" *ngIf="hasLegalRepresentation"></th>
            <!--<th *ngIf="hasLegalRepresentation" scope="col">{{'PrestacoesMorte.StepBeneficiary.Cards.BeneficiaryList.Fields.StateRL' | translate}}</th>-->
            <th scope="col">{{'PrestacoesMorte.StepBeneficiary.Cards.BeneficiaryList.Fields.Name' | translate}}</th>
            <th scope="col">{{'PrestacoesMorte.StepBeneficiary.Cards.BeneficiaryList.Fields.DateOfBirth' | translate}}</th>
            <th scope="col">{{'PrestacoesMorte.StepBeneficiary.Cards.BeneficiaryList.Fields.HasPortugueseNationality' | translate}}</th>

            <th scope="col">{{'PrestacoesMorte.StepBeneficiary.Cards.BeneficiaryList.Fields.Nif' | translate}}</th>
            <th scope="col">{{'PrestacoesMorte.StepBeneficiary.Cards.BeneficiaryList.Fields.RepresentationType' | translate}}</th>
            <th scope="col">{{'PrestacoesMorte.StepBeneficiary.Cards.BeneficiaryList.Fields.BenefitType' | translate}}</th>
            <th scope="col"></th>
          </tr>
        </thead>
        <tbody>
          <ng-container *ngFor="let tableItem of model.beneficiaryList; let i = index ">
            <tr [ngClass]="expandedRowIndex == i ? 'text-primary table-active-top-border' : 'enabled'" (click)="expandRow(i)">
              <td *ngIf="hasLegalRepresentation.toString()=='true'" class="icon" 
                  [tooltip]="hasIconRL(tableItem) ? getStateText(tableItem.stateRL?.toString()) :''"
                  [style.color]="getStateColor(tableItem.stateRL?.toString())">
                <i *ngIf=" hasIconRL(tableItem)"
                   style="font-size:20px" class="icon-user"></i>
              </td>
              <!--<td *ngIf="hasLegalRepresentation">{{getStateText(tableItem.stateRL?.toString())}}</td>-->
              <td>{{tableItem.beneficiaryName}}</td>
              <td>{{tableItem.dateOfBirth | date:'yyyy-MM-dd'}}</td>
              <td>{{tableItem.hasNacPT?.toString() == 'true' ? 'Sim':'Não'}}</td>
              <td>{{tableItem.NIF}}</td>
              <td>{{tableItem.NIF==senderNIF ? '-':  (tableItem.representationType | dropdowns:'DropdownRepresentationType':dropdowns)}}</td>
              <td>{{benefitLabelAppearingFunction(tableItem.survivalPensionBenefit, tableItem.reimbursementFuneralBenefit, tableItem.funeralAllowanceBenefit)}}</td>
              <td class="buttons-edit" [ngClass]="expandedRowIndex == enabled ? 'active' : 'inactive'">
                <button type="button" class="btn-icon"
                        aria-label="Editar" [attr.aria-expanded]="expandedRowIndex == i" aria-controls="collapseBasic">
                  <span class="p-1 text-primary " [ngClass]="getIconEditar(expandedRowIndex == i)"
                        [style.color]="!isItemReady(tableItem) ? 'var(--bs-danger) !important':'inherit'"
                        placement="bottom" [tooltip]="!isItemReady(tableItem) ? ('WorkflowCreatePM.PreStage.CardHabilitandos.Tooltips.IsHabilitandoNotComplete' | translate):''"></span>
                </button>
                @if(!estadoPendente){
                <button type="button" class="btn-icon" aria-label="Apagar" *ngIf="( isFuneraryOrService?.toString()=='true');else tooltipIsSender">
                  <ng-container *ngIf="tableItem.representationType== null;else tooltipIsRepresentado ">
                    <span class="icon-trash p-1" *ngIf="(isFuneraryOrService?.toString()=='true') " (click)="removeFromList(model.beneficiaryList, tableItem ,$event)" [ngClass]="expandedRowIndex == i ? 'text-primary' : 'text-primary'"></span>
                  </ng-container>
                  <ng-template #tooltipIsRepresentado>
                    <span class="icon-info p-1" placement="bottom" [tooltip]="'WorkflowCreatePM.PreStage.CardHabilitandos.Tooltips.IsSenderRepresentado' | translate"></span>
                  </ng-template>
                </button>
                <ng-template #tooltipIsSender>
                  <span class="icon-info p-1" placement="bottom" [tooltip]="'WorkflowCreatePM.PreStage.CardHabilitandos.Tooltips.IsSenderBeneficiary' | translate"></span>
                </ng-template>
                }

              </td>
            </tr>
            <tr *ngIf="expandedRowIndex == i" [collapse]="expandedRowIndex != i" [isAnimated]="false" class="table-active-bottom-border">
              <td class="p-0" colspan="7" id="collapseBasic">
                <div class=" p-4 ">
                  <beneficiary-list-table-edit-pre-stage
                                                         [nifDeceased]="nifDeceased"
                                                         [dropdowns]="dropdowns" [itemList]="model.beneficiaryList"
                                                         
                                                         [senderNIF]="senderNIF"
                                                          [isFuneraryOrService]="isFuneraryOrService"
                                                         [workflowInstanceId]="workflowInstanceId"
                                                         [deceasedSubscriberNumber]="deceasedSubscriberNumber"
                                                         [qualificationIsBeneficiary]="qualificationIsBeneficiary"
                                                         [qualificationIsLegalRepresentative]="qualificationIsLegalRepresentative"
                                                         [workflowCode]="workflowCode"
                                                         [estadoPendente]="estadoPendente"
                                                         [editIndex]="i" (listChanged)="onBeneficiaryChanged($event)"
                                                         (isClosing)="isClosingAction()"
                                                         [deathDate]="deathDate"
                                                         [hasLegalRepresentation]="hasLegalRepresentation"></beneficiary-list-table-edit-pre-stage>
                </div>
              </td>
            </tr>
          </ng-container>
        </tbody>
      </table>

      <!-- TODO :  Find a better way to do this both the boolean cast and the input "binding"-->
      <!--<input hidden [class.ng-invalid]="model?.beneficiaryList?.length < 1" />-->
      <validation-message *ngIf="model?.beneficiaryList?.length < 1" message="{{'ValidationMessages.atleastOneElement' | translate}}"></validation-message>

    </div>
  </div>

  <div class="row">
    <div class="col-sm-12">
      <!--New table entry inputs-->
      <div *ngIf="expandNewBeneficiary" class="shadow ml-2 mr-2 p-4 mb-2 mt-2">

        <beneficiary-list-table-edit-pre-stage
                                               [nifDeceased]="nifDeceased"
                                               [dropdowns]="dropdowns"
                                               [senderName]="senderName"
                                               [itemList]="model.beneficiaryList"
                                               [senderNIF]="senderNIF"
                                               [workflowInstanceId]="workflowInstanceId"
                                               [qualificationIsBeneficiary]="qualificationIsBeneficiary"
                                               [qualificationIsLegalRepresentative]="qualificationIsLegalRepresentative"
                                               (listChanged)="onBeneficiaryChanged($event)"
                                               (isClosing)="isClosingAction()"
                                               [estadoPendente]="estadoPendente"
                                               [deceasedSubscriberNumber]="deceasedSubscriberNumber"
                                               [workflowCode]="workflowCode"
                                               [isFuneraryOrService]="isFuneraryOrService"
                                               [deathDate]="deathDate"
                                               [hasLegalRepresentation]="hasLegalRepresentation"></beneficiary-list-table-edit-pre-stage>
      </div>
    </div>
  </div>
</main>
